import { Model } from '@/models/Model';
import client from '@/support/Client';
import { DateTime } from 'luxon';
export class Timeslot extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Timeslot';
        this.$endpoint = '/timeslots';
        this.$fillable = ['starts_at', 'ends_at', 'template', 'title', 'day'];
    }
    get calendarEvent() {
        const parsedEvent = {
            id: this.id || '',
            title: this.title || '',
            start: this.starts_at ? DateTime.fromSQL(this.starts_at).toISO() : '',
            end: this.ends_at ? DateTime.fromSQL(this.ends_at).toISO() : '',
            extendedProps: {
                type: this.type,
                activities: this.activities,
                is_valid: this.is_valid,
                audits: this.audits,
            },
            editable: true,
            className: `slot__event`,
        };
        return parsedEvent;
    }
    validate(id) {
        return client('get', `${this.$endpoint}/${this.id}/validate`, {});
    }
    audit() {
        const url = this.$endpoint + '/' + this.resolvePrimaryKey() + '/audits';
        return client('get', url, {}).then((response) => {
            return Promise.resolve(response.data);
        }, (error) => {
            return Promise.reject(error);
        });
    }
}
